import { BiSearch, BiMailSend } from "react-icons/bi";
import { SearchBar } from "../Chats/style";
import { ContactContainer, ContactScrollWrapper, ContactUser } from "./style";
import { FiXCircle } from "react-icons/fi";
import { useState, useEffect } from "react";
import InviteButton from "../InviteButton";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { io, Socket } from "socket.io-client";


interface DataItem {
  userId: string;
  userName: string;
  image: string;
  chatId: string;
  conversationId: string;
}

interface NewChatProps {
  onSelect: (data: DataItem) => void;
}

const Contact = ({ onSelect }: NewChatProps) => {
  const [sockets, setSockets] = useState<Socket<any, any> | null>(null);
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState<DataItem[]>([]);
  const storedToken = sessionStorage.getItem("token");
  const myChatId = sessionStorage.getItem("chatId");
  const token = `Bearer ${storedToken}`;
  const navigate = useNavigate();

  useEffect(() => {
    if (!storedToken) {
      navigate("/login", { replace: true });
    }
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_ENDPOINT}/users`, {
        headers: Authorization,
      })
      .then((res: any) => {
        setData(res.data.result);
      })
      .catch((err) => {});
  }, []);

  const filteredData = data.filter(
    (item) =>
      item &&
      item.userName &&
      item.userName.toLowerCase().includes(searchText.toLowerCase())
  );

  const clearSearch = () => {
    setSearchText("");
  };

  const handleUserClick = (data: DataItem) => {
    const starterpayload = {
      messenger1: myChatId,
      messenger2: data.chatId,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_ENDPOINT}/conversation`,
        starterpayload,
        {
          headers: Authorization,
        }
      )
      .then((res: any) => {
        const user = {
          userId: data.userId,
          chatId: "",
          userName: data.userName,
          image: data.image,
          conversationId: res.data.conversationId,
        };
        onSelect(user);
      })
      .catch((err: any) => {
        if (err.response.status === 409) {
          const user = {
            userId: data.userId,
            chatId: "",
            userName: data.userName,
            image: data.image,
            conversationId: err.response.data.conversationId,
          };
          onSelect(user);
        } else {
          console.log("user not found");
        }
      });
  };

  return (
    <ContactContainer>
      <SearchBar>
        <BiSearch size={20} />
        <input
          type="text"
          placeholder="Search"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        {searchText && (
          <FiXCircle
            onClick={clearSearch}
            size={22}
            style={{ cursor: "pointer", color: "#d46666" }}
          />
        )}
      </SearchBar>
      {searchText ? (
        <ContactScrollWrapper>
          {filteredData.length === 0 ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "60vh",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <span>No users match your search.</span>
              <InviteButton
                spanText="send invite"
                icon={<BiMailSend color="#fff" />}
                CustomButtonClick={() => {
                  console.log("sending invite...");
                }}
              />
            </div>
          ) : (
            filteredData.map((item, index) => (
              <ContactUser key={index}>
                <div>
                  <img
                    src={item.image || "image/Default_Profile.png"}
                    alt="avatar"
                  />
                  <div>
                    <span>{item.userName || "User not Verified"}</span>
                    <span>Start the conversation</span>
                  </div>
                </div>
                <div>
                  {item.chatId === myChatId ? (
                    <></>
                  ) : (
                    <>
                      <button
                        disabled={!item.userName || item.chatId === myChatId}
                        style={{
                          cursor:
                            !item.userName || item.chatId === myChatId
                              ? "not-allowed"
                              : "",
                          backgroundColor:
                            !item.userName || item.chatId === myChatId
                              ? "#2e2e2ea6"
                              : "",
                        }}
                        onClick={() => {
                          handleUserClick(item);
                        }}
                      >
                        Chat
                      </button>
                    </>
                  )}
                </div>
              </ContactUser>
            ))
          )}
        </ContactScrollWrapper>
      ) : (
        <ContactScrollWrapper>
          {data.map((item, index) => (
            <ContactUser key={index}>
              <div>
                <img
                  src={item.image || "image/Default_Profile.png"}
                  alt="avatar"
                />
                <div>
                  <span>{item.userName || "unverified"}</span>
                  <span>Start the conversation</span>
                </div>
              </div>
              <div>
                {item.chatId === myChatId ? (
                  <></>
                ) : (
                  <>
                    <button
                      disabled={!item.userName || item.chatId === myChatId}
                      style={{
                        cursor:
                          !item.userName || item.chatId === myChatId
                            ? "not-allowed"
                            : "",
                        backgroundColor:
                          !item.userName || item.chatId === myChatId
                            ? "#2e2e2ea6"
                            : "",
                      }}
                      onClick={() => {
                        handleUserClick(item);
                      }}
                    >
                      Chat
                    </button>
                  </>
                )}
              </div>
            </ContactUser>
          ))}
        </ContactScrollWrapper>
      )}
    </ContactContainer>
  );
};

export default Contact;
